import { backButton } from '@telegram-apps/sdk-react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

/** Telegram'ning o'z BackButton'ini router bilan bog'laydi (SPEC §11). */
export function BackButtonSync() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!backButton.isMounted()) return;
    if (pathname === '/') {
      backButton.hide();
      return;
    }
    backButton.show();
    return backButton.onClick(() => navigate(-1));
  }, [pathname, navigate]);

  return null;
}
